module.exports = __webpack_public_path__ + "static/media/nypost.com_2016_08_01_melania-trumps-girl-on-girl-photos-from-racy-shoot-revealed__plot.356ad3db.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/nypost.com_2016_08_01_melania-trumps-girl-on-girl-photos-from-racy-shoot-revealed__plot.png
// module id = 402
// module chunks = 0